import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import { type AuthenticationStrategiesConfig } from "@jti/rest-api-types";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { CasAuthApi } from "../../../services";

export const useAuthenticationMethods = (): UseQueryResult<AuthenticationStrategiesConfig> => {
  return useQuery(
    QUERY_KEYS.authenticationStrategies,
    async () => {
      const response = await CasAuthApi.init().getAvailableAuthMethods();

      return response.availableAuthMethods;
    },
    {
      retry: false,
    }
  );
};
